import { render } from "./menuEntry.vue?vue&type=template&id=047fa132&ts=true"
import script from "./menuEntry.vue?vue&type=script&lang=ts"
export * from "./menuEntry.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__